import { Module } from 'vuex'
import actions from '@/modules/common/store/entityActions'
import mutations from '@/modules/common/store/entityMutations'
import getters from '@/modules/common/store/entityGetters'
import RootState from '@/store/rootState'
import EntityState from '@/modules/common/store/entityState'
import EntityService from '@/modules/common/services/entityService'
import CashBoxResource from '@/modules/sale/services/cashBoxResource'
import CashBox from '@/modules/sale/domain/cashbox'

const entityService = new EntityService<CashBox>(CashBoxResource, CashBox)
const cashBoxModule: Module<EntityState<CashBox>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(entityService, 'cash-box')
}

export default cashBoxModule
